import React from 'react'
import './Hero.css'
import Header from '../Header/Header'
import heart from '../../assets/heart.png'
import hero_image from '../../assets/hero_image.png'
import hero_image_back from '../../assets/hero_image_back.png'
import calories from '../../assets/calories.png'
import {motion} from 'framer-motion'
import Numbercounter from 'number-counter'
const Hero = () => {
  const transition={type: 'spring', duration: 3}
  const mobile = window.innerWidth <= 768 ? true : false
  return (
    <div className='hero' id='home'>
      <div className='blur hero-blur'></div>
        <div className='left-hero'>
          <Header />
          
          <div className='the-best-add'>

            {/* the best add */}
              <motion.div
                initial={{left: mobile? '190px': '268px', opacity: 0}}
                whileInView={{left: '8px', opacity: 1}}
                transition={{...transition, type:'tween'}}
              ></motion.div>
              <span>THE BEST FITNESS CLUB IN THE TOWN</span>
          </div>

          <div className='hero-text'>
              <div>
                  <div className='col'>
                    <span className='stroke-text'>Shape</span>
                    <span>Your</span>
                  </div>
                  <div>
                    <span>Ideal body</span>
                  </div>
                  <div className='text-description'>
                    In here we wil help you to shape and build your ideal body and live your life to fullest
                  </div>
              </div>
          </div>
          <div className='figures'>
              <div>
                <span><Numbercounter end={140} start={100} delay='4' preFix='+'/></span>
                <span>Expert Coachs</span>
              </div>
              <div>
                <span><Numbercounter end={978} start={900} delay='4' preFix='+'/></span>
                <span>Members Joined</span> </div>
              <div>
                <span><Numbercounter end={50} start={20} delay='4' preFix='+'/></span>
                <span>Fitness programs </span>
              </div>
          </div>
          <div className='button-hero'>
            <button className='btn'>Get Started</button>
            <button className='btn'>Learn More</button>
          </div>
          
        </div>
           
        <div className='right-hero'>
          <button className='btn'>Join Now</button>

          <motion.div
           initial={{right: '-1rem'}}
            whileInView={{right: '4rem'}}
            transition={transition}
            className='heart-rate'>
            <img className='heart' src={heart} alt='heart-rate' border='0' />
            <span>Heart Rate</span><span>116 bpm</span>
          </motion.div>
          
          <img  src={hero_image} alt='' className='hero-image' />
          <motion.img 
            initial={{right: '11rem'}}
            whileInView={{right: '20rem'}}
            transition={transition}
          src={hero_image_back} alt='' className='hero-image-back' />

          <motion.div 
            initial ={{right: '35rem'}}
            whileInView={{right: '29rem'}}
            transition={transition}
            className='calories'>
            <img src={calories} alt='' />
            <div className='calories-text'>
              <span>Calories</span><span>220KCAL</span>
            </div>
          </motion.div>
        </div>
    </div>
  )
}

export default Hero